var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTofu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.316883 5.70161L7.69375 1.42092L20.012 3.59959L12.6348 7.88001L0.316883 5.70161Z",
    fill: "#F1ECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6348 7.88001L20.012 3.59959L19.707 14.6344L12.3299 18.9151L12.6348 7.88001Z",
    fill: "#D2AF73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6348 7.88001L12.3299 18.9151L0.0119629 16.7364L0.316883 5.70161L12.6348 7.88001Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24054 4.98986L4.35309 4.31684L4.50417 4.82504L3.76248 4.98986H3.24054Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68273 5.66288L5.79528 4.98986L5.94636 5.49806L5.20467 5.66288H4.68273Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0599 4.37865L6.17244 3.70562L6.32353 4.21382L5.58183 4.37865H5.0599Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88659 5.62497L8.99914 4.95195L9.15022 5.46015L8.40852 5.62497H7.88659Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 5.05167L14.7129 4.37865L14.864 4.88685L14.1223 5.05167H13.6004Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51841 4.21025L9.63095 3.53723L9.78204 4.04543L9.04034 4.21025H8.51841Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3786 5.99939L15.4912 5.32637L15.6423 5.83457L14.9006 5.99939H14.3786Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6438 5.88594L11.7563 5.21292L11.9074 5.72112L11.1657 5.88594H10.6438Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25477 3.70562L8.36732 3.0326L8.5184 3.5408L7.77671 3.70562H7.25477Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 4.85608L13.1156 4.18306L13.2666 4.69126L12.5249 4.85608H12.003Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7744 2.98453L6.88695 2.31151L7.03803 2.81971L6.29634 2.98453H5.7744Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74833 6.37464L9.86088 5.70161L10.012 6.20981L9.27027 6.37464H8.74833Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3339 3.57514L15.4464 2.90212L15.5975 3.41032L14.8558 3.57514H14.3339Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.012 7.18501L11.1245 6.51199L11.2756 7.02019L10.5339 7.18501H10.012Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58716 6.28069L6.40622 5.73623L6.74245 5.32637L7.2946 5.84831L7.58716 6.28069Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62982 4.35475L7.9267 4.45034L7.75556 4.95195L7.05534 4.65692L6.62982 4.35475Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20296 2.14339L10.4996 2.23899L10.3287 2.74059L9.62848 2.44556L9.20296 2.14339Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5559 4.17262L17.8525 4.26794L17.6814 4.76982L16.9814 4.47479L16.5559 4.17262Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7245 3.74353L16.0211 3.83913L15.8502 4.34074L15.15 4.04571L14.7245 3.74353Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4303 3.87374L11.7272 3.96934L11.5561 4.47122L10.8559 4.17619L10.4303 3.87374Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9321 2.60352L13.2287 2.69911L13.0576 3.20072L12.3576 2.90569L11.9321 2.60352Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58716 2.14339L8.88376 2.23899L8.71262 2.74059L8.01268 2.44556L7.58716 2.14339Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5154 6.51199L12.812 6.60731L12.6409 7.10919L11.9409 6.81416L11.5154 6.51199Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13346 2.94003L10.4303 3.03562L10.2592 3.53723L9.55898 3.2422L9.13346 2.94003Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0786 3.07051L12.3755 3.16611L12.2044 3.66771L11.5041 3.37268L11.0786 3.07051Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6183 5.58734L13.9152 5.68293L13.7441 6.18482L13.0439 5.88951L12.6183 5.58734Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51585 4.51957L10.8127 4.61516L10.6416 5.11677L9.94136 4.82174L9.51585 4.51957Z",
    fill: "#EADEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.812 3.44466L14.1089 3.54025L13.9377 4.04213L13.2375 3.7471L12.812 3.44466Z",
    fill: "#EADEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTofu);
export default __webpack_public_path__ + "static/media/tofu.ccfee93c2417d8a66b36dabde5bc30c3.svg";
export { ForwardRef as ReactComponent };